import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService, BUTTON } from '@unive/analytics';
import {
  aboutLink,
  aovAppointmentLink,
  appointmentLink,
  customerAppreciationLink,
  disclaimerLink,
  facebookLink,
  instagramLink,
  linkedInLink,
  LoaderService,
  orvAppointmentLink,
  pensionAppointmentLink,
  privacyLink,
  reportVulnerabilityLink,
  RoutesEnum,
  storesLink,
  websiteLink,
  xLink,
  youtubeLink,
} from '@unive/core';
import { NavigationItemInterface } from '@unive/ui';

@Component({
  templateUrl: 'page.layout.html',
})
export class PageLayout implements OnInit {
  public aboutUrl: string = aboutLink;
  public customerAppreciationUrl: string = customerAppreciationLink;
  public storesUrl: string = storesLink;
  public websiteUrl: string = websiteLink;
  public navigationItems: NavigationItemInterface[] = [{ route: '/', label: 'Financieel inzicht' }];
  public disclaimerLink: string = disclaimerLink;
  public privacyLink: string = privacyLink;
  public reportVulnerabilityLink: string = reportVulnerabilityLink;
  public facebookLink: string = facebookLink;
  public xLink: string = xLink;
  public instagramLink: string = instagramLink;
  public linkedInLink: string = linkedInLink;
  public youtubeLink: string = youtubeLink;
  public isLoading: boolean = false;

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private analyticsService: AnalyticsService,
  ) {}

  public ngOnInit(): void {
    this.loaderService.getIsLoading$().subscribe((isLoading: boolean): void => {
      this.isLoading = isLoading;
    });
  }

  public onAppointment(): void {
    this.analyticsService.trackButton({
      type: BUTTON.Appointment,
      name: 'Maak een afspraak',
      location: this.getCurrentRoute('header'),
    });

    if (this.router.url.indexOf(RoutesEnum.Aov) === 1) {
      window.open(aovAppointmentLink, '_blank');
    } else if (this.router.url.indexOf(RoutesEnum.Orv) === 1) {
      window.open(orvAppointmentLink, '_blank');
    } else if (this.router.url.indexOf(RoutesEnum.Pension) === 1) {
      window.open(pensionAppointmentLink, '_blank');
    } else {
      window.open(appointmentLink, '_blank');
    }
  }

  public onSocial(platform: string): void {
    this.analyticsService.trackButton({
      type: BUTTON.Social,
      name: platform,
      location: this.getCurrentRoute('footer'),
    });
  }

  public onInfo(label: string): void {
    this.analyticsService.trackButton({
      type: BUTTON.Information,
      name: label,
      location: this.getCurrentRoute('footer'),
    });
  }

  private getCurrentRoute(section: string): string {
    const url: string = this.router.routerState.snapshot.url
      .split('/')
      .filter((segment: string): boolean => !!segment)
      .join(':');
    return `${url}:${section}`;
  }
}
